module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "TetherLogo.6d30f474.svg";